// @flow
import memoize from "lru-memoize"
import shallowEqual from "./shallowEqual"

export default (limit: number = 1) => memoize(limit, shallowEqual, false)
